// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__JFuaQ","title":"ClientReferral_title__2Lwt3","itemText":"ClientReferral_itemText__2mE1V"};